import { useState, useEffect } from "react";
import {
    CircularProgress,
    Container,
    Grid,
    Typography,
    TextField,
    List,
    ListItemButton,
    ListItemText,
    ListItemIcon,
    Checkbox,
    Collapse,
    Button,
    Box,
    Rating,
    useMediaQuery,
    Accordion,
    AccordionDetails,
    AccordionSummary,
} from "@mui/material";

import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import EditIcon from "@mui/icons-material/Edit";
import OutputIcon from "@mui/icons-material/Output";

import { getAuth } from "firebase/auth";
import { db } from "../../firebase";
import { getDoc, doc } from "firebase/firestore";

import { useNavigate } from "react-router-dom";

import { Helmet } from "react-helmet-async";

function ScinarioDetail() {
    const [loading, setLoading] = useState(true);

    const [user, setUser] = useState("");
    const [param, setParam] = useState("");
    const navigate = useNavigate();

    const isSP = useMediaQuery("(max-width:600px)");

    const [viewportHeight, setViewportHeight] = useState(0);

    const getTextFieldRows = () => {
        if (!viewportHeight) return 29;
        return Math.floor((viewportHeight - 300) / 22);
    };

    const [title, setTitle] = useState("");
    const [kpInfo, setKpinfo] = useState([]);
    const [stories, setStories] = useState([]);
    const [endings, setEndings] = useState([]);
    const [auther, setAuther] = useState("");

    const [accordionExpand, setAccordionExpand] = useState(false);
    const handleAccordionExpandChange = () => {
        setAccordionExpand(!accordionExpand);
    };

    const [expanded01, setExpanded01] = useState(true);
    const handleExpand01 = () => {
        setExpanded01(!expanded01);
    };

    const [expanded02, setExpanded02] = useState(true);
    const handleExpand02 = () => {
        setExpanded02(!expanded02);
    };

    const [expanded03, setExpanded03] = useState(true);
    const handleExpand03 = () => {
        setExpanded03(!expanded03);
    };

    const [selectedInfoId, setSelectedInfoId] = useState(1);
    const handleInfoClick = (infoId) => {
        setSelectedInfoId(infoId);
        setSelectedStoryId(null);
        setSelectedEndId(null);
        setAccordionExpand(!accordionExpand);
    };

    const [selectedStoryId, setSelectedStoryId] = useState(null);
    const handleStoryClick = (storyId) => {
        setSelectedStoryId(storyId);
        setSelectedInfoId(null);
        setSelectedEndId(null);
        setAccordionExpand(!accordionExpand);
    };

    const [selectedEndId, setSelectedEndId] = useState(null);
    const handleEndClick = (endId) => {
        setSelectedEndId(endId);
        setSelectedInfoId(null);
        setSelectedStoryId(null);
        setAccordionExpand(!accordionExpand);
    };

    const scinarioData = {
        data: {
            title: title,
            kpInfo: [...kpInfo],
            stories: [...stories],
            endings: [...endings],
        },
    };

    const handleOutput = () => {
        const json = JSON.stringify(scinarioData, null, 2);
        const blob = new Blob([json], { type: "application/json" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = "scinario_" + title + ".json";
        link.click();
    };

    const handleEdit = () => {
        window.scrollTo(0, 0);
        navigate(`/scenario/${param}/edit`);
    };

    const fetchData = async (uid) => {
        const params = window.location.pathname.split("/")[2];
        setParam(params);

        const scinaRef = doc(db, "scinario", params);
        const scinaSnap = await getDoc(scinaRef);

        if (scinaSnap.exists()) {
            if (scinaSnap.data().deleted === true) {
                window.scrollTo(0, 0);
                navigate(-1, { replace: true });
            } else {
                if (scinaSnap.data().auther === uid) {
                    setTitle(scinaSnap.data().title);
                    setKpinfo(scinaSnap.data().kpInfo);
                    setStories(scinaSnap.data().stories);
                    setEndings(scinaSnap.data().endings);
                    setAuther(scinaSnap.data().auther);
                } else if (scinaSnap.data().private === false) {
                    setTitle(scinaSnap.data().title);
                    setKpinfo(scinaSnap.data().kpInfo);
                    setStories(scinaSnap.data().stories);
                    setEndings(scinaSnap.data().endings);
                    setAuther(scinaSnap.data().auther);
                }
            }
        }

        setLoading(false);
    };

    useEffect(() => {
        const unsubscribe = getAuth().onAuthStateChanged(async (userLogin) => {
            if (userLogin) {
                const uid = userLogin.uid;
                setUser(uid);
                await fetchData(uid);
            } else {
                window.scrollTo(0, 0);
                navigate("/login", { replace: true });
            }
        });

        // 画面の高さを取得
        const updateViewportHeight = () => {
            setViewportHeight(window.innerHeight);
        };

        updateViewportHeight();
        window.addEventListener("resize", updateViewportHeight);

        return () => {
            unsubscribe();
            window.removeEventListener("resize", updateViewportHeight);
        };
    }, []);

    if (loading) {
        return (
            <Box
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "80vh",
                }}
            >
                <CircularProgress />
            </Box>
        );
    }

    return (
        <div>
            <Helmet>
                <title>Scinario Detail - SOG Member Site</title>
                <meta name="robots" content="noindex, nofollow" />
            </Helmet>

            <Container maxWidth="1280" sx={{ display: { xs: { maxWidth: 0 } }, maxWidth: 1280 }}>
                {isSP ? (
                    <Box>
                        <Accordion
                            expanded={accordionExpand}
                            onChange={handleAccordionExpandChange}
                            sx={{ maxHeight: `calc(${viewportHeight}px - 80px)` }}
                        >
                            <AccordionSummary expandIcon={<ExpandMoreIcon />}>メニュー</AccordionSummary>
                            <AccordionDetails>
                                <TextField
                                    label="タイトル"
                                    variant="standard"
                                    value={title}
                                    fullWidth
                                    inputProps={{
                                        readOnly: true,
                                    }}
                                />
                                <Box
                                    sx={{
                                        maxHeight: `calc(${viewportHeight}px - 300px)`,
                                        overflow: "auto",
                                        mt: 2,
                                    }}
                                >
                                    <List sx={{ mt: 2 }}>
                                        <ListItemButton onClick={handleExpand01}>
                                            <ListItemText primary="キーパー情報" />
                                            {expanded01 ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                                        </ListItemButton>
                                        <Collapse in={expanded01} timeout="auto" unmountOnExit>
                                            <List component="div" disablePadding>
                                                {kpInfo.map((info) => (
                                                    <ListItemButton
                                                        key={info.id}
                                                        onClick={() => handleInfoClick(info.id)}
                                                        selected={selectedInfoId === info.id}
                                                    >
                                                        <ListItemIcon
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                            }}
                                                        >
                                                            <Checkbox edge="start" />
                                                        </ListItemIcon>
                                                        <ListItemText primary={`${info.title}`} />
                                                    </ListItemButton>
                                                ))}
                                            </List>
                                        </Collapse>
                                    </List>

                                    <List>
                                        <ListItemButton onClick={handleExpand02}>
                                            <ListItemText primary="本編" />
                                            {expanded02 ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                                        </ListItemButton>
                                        <Collapse in={expanded02} timeout="auto" unmountOnExit>
                                            <List component="div" disablePadding>
                                                {stories.map(({ id, title }, index) => (
                                                    <ListItemButton key={id} onClick={() => handleStoryClick(id)} selected={selectedStoryId === id}>
                                                        <ListItemIcon
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                            }}
                                                        >
                                                            <Checkbox edge="start" />
                                                        </ListItemIcon>
                                                        <ListItemText primary={title} />
                                                    </ListItemButton>
                                                ))}
                                            </List>
                                        </Collapse>
                                    </List>

                                    <List>
                                        <ListItemButton onClick={handleExpand03}>
                                            <ListItemText primary="エンディング" />
                                            {expanded03 ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                                        </ListItemButton>
                                        <Collapse in={expanded03} timeout="auto" unmountOnExit>
                                            <List component="div" disablePadding>
                                                {endings.map(({ id, title }, index) => (
                                                    <ListItemButton key={id} onClick={() => handleEndClick(id)} selected={selectedEndId === id}>
                                                        <ListItemIcon
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                            }}
                                                        >
                                                            <Checkbox edge="start" />
                                                        </ListItemIcon>
                                                        <ListItemText primary={title} />
                                                    </ListItemButton>
                                                ))}
                                            </List>
                                        </Collapse>
                                    </List>
                                </Box>

                                <Box
                                    sx={{ my: 2 }}
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                    }}
                                >
                                    <Button sx={{ mx: 1, py: 1, width: 190 }} color="secondary" variant="contained" onClick={handleOutput}>
                                        <OutputIcon sx={{ mx: 1 }} /> 出力
                                    </Button>

                                    <Button
                                        sx={{ mx: 1, py: 1, width: 190 }}
                                        variant="contained"
                                        onClick={handleEdit}
                                        disabled={user !== auther && true}
                                    >
                                        <EditIcon sx={{ mx: 1 }} /> 編集
                                    </Button>
                                </Box>
                            </AccordionDetails>
                        </Accordion>

                        {selectedInfoId === 1 ? (
                            <div>
                                <Grid container spacing={2} sx={{ mt: 1 }}>
                                    <Grid item xs={6}>
                                        <Typography sx={{ textAlign: "center" }}>キーパー難易度</Typography>
                                        <Rating
                                            style={{
                                                display: "flex",
                                                justifyContent: "center",
                                                margin: "0 auto",
                                            }}
                                            value={kpInfo.find((info) => info.id === 1).kpLevel}
                                            readOnly
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Typography sx={{ textAlign: "center" }}>プレイヤー難易度</Typography>
                                        <Rating
                                            style={{
                                                display: "flex",
                                                justifyContent: "center",
                                                margin: "0 auto",
                                            }}
                                            value={kpInfo.find((info) => info.id === 1).plLevel}
                                            readOnly
                                        />
                                    </Grid>
                                </Grid>
                                <TextField
                                    label="推奨人数"
                                    variant="standard"
                                    fullWidth
                                    sx={{ mt: 2 }}
                                    value={kpInfo.find((info) => info.id === 1).numberPeople}
                                    inputProps={{
                                        readOnly: true,
                                    }}
                                />
                                <TextField
                                    label="プレイ時間"
                                    variant="standard"
                                    fullWidth
                                    sx={{ mt: 2 }}
                                    value={kpInfo.find((info) => info.id === 1).playTime}
                                    inputProps={{
                                        readOnly: true,
                                    }}
                                />
                                <TextField
                                    label="シナリオの概要"
                                    variant="outlined"
                                    sx={{
                                        mt: 2,
                                        mb: 2,
                                        height: "calc(100vh - 350px)",
                                        "& .MuiInputBase-root": {
                                            height: "100%",
                                            "& textarea": {
                                                height: "100% !important",
                                                overflow: "auto !important",
                                            },
                                        },
                                    }}
                                    value={kpInfo.find((info) => info.id === 1).infoContent}
                                    multiline
                                    rows={getTextFieldRows()}
                                    fullWidth
                                    inputProps={{
                                        readOnly: true,
                                    }}
                                />
                            </div>
                        ) : selectedInfoId === 2 ? (
                            <div>
                                <TextField
                                    label="技能について"
                                    placeholder="推奨技能などがあれば、記載してください"
                                    variant="outlined"
                                    sx={{ mt: 2 }}
                                    value={kpInfo.find((info) => info.id === 2).skill}
                                    multiline
                                    rows={5}
                                    fullWidth
                                    inputProps={{
                                        readOnly: true,
                                    }}
                                />
                                <TextField
                                    label="探索者について"
                                    placeholder="職業の指定や、年齢制限、ハンドアウトなどあれば、記載してください"
                                    variant="outlined"
                                    sx={{
                                        mt: 2,
                                        mb: 2,
                                        height: "calc(100vh - 320px)",
                                        "& .MuiInputBase-root": {
                                            height: "100%",
                                            "& textarea": {
                                                height: "100% !important",
                                                overflow: "auto !important",
                                            },
                                        },
                                    }}
                                    value={kpInfo.find((info) => info.id === 2).plContent}
                                    multiline
                                    rows={getTextFieldRows()}
                                    fullWidth
                                    inputProps={{
                                        readOnly: true,
                                    }}
                                />
                            </div>
                        ) : selectedInfoId === 3 ? (
                            <TextField
                                label="NPC情報"
                                variant="outlined"
                                sx={{
                                    mt: 2,
                                    mb: 2,
                                    height: "calc(100vh - 160px)",
                                    "& .MuiInputBase-root": {
                                        height: "100%",
                                        "& textarea": {
                                            height: "100% !important",
                                            overflow: "auto !important",
                                        },
                                    },
                                }}
                                value={kpInfo.find((info) => info.id === 3).npcContent}
                                multiline
                                rows={getTextFieldRows()}
                                fullWidth
                                inputProps={{
                                    readOnly: true,
                                }}
                            />
                        ) : selectedInfoId === 4 ? (
                            <TextField
                                label="アイテム等"
                                variant="outlined"
                                sx={{
                                    mt: 2,
                                    mb: 2,
                                    height: "calc(100vh - 160px)",
                                    "& .MuiInputBase-root": {
                                        height: "100%",
                                        "& textarea": {
                                            height: "100% !important",
                                            overflow: "auto !important",
                                        },
                                    },
                                }}
                                value={kpInfo.find((info) => info.id === 4).itemContent}
                                multiline
                                rows={getTextFieldRows()}
                                fullWidth
                                inputProps={{
                                    readOnly: true,
                                }}
                            />
                        ) : selectedInfoId === 5 ? (
                            <TextField
                                label="あらすじ"
                                variant="outlined"
                                sx={{
                                    mt: 2,
                                    mb: 2,
                                    height: "calc(100vh - 160px)",
                                    "& .MuiInputBase-root": {
                                        height: "100%",
                                        "& textarea": {
                                            height: "100% !important",
                                            overflow: "auto !important",
                                        },
                                    },
                                }}
                                value={kpInfo.find((info) => info.id === 5).synopsisContent}
                                multiline
                                rows={getTextFieldRows()}
                                fullWidth
                                inputProps={{
                                    readOnly: true,
                                }}
                            />
                        ) : selectedInfoId === 6 ? (
                            <TextField
                                label="真相"
                                variant="outlined"
                                sx={{
                                    mt: 2,
                                    mb: 2,
                                    height: "calc(100vh - 160px)",
                                    "& .MuiInputBase-root": {
                                        height: "100%",
                                        "& textarea": {
                                            height: "100% !important",
                                            overflow: "auto !important",
                                        },
                                    },
                                }}
                                value={kpInfo.find((info) => info.id === 6).truthContent}
                                multiline
                                rows={getTextFieldRows()}
                                fullWidth
                                inputProps={{
                                    readOnly: true,
                                }}
                            />
                        ) : selectedStoryId !== null ? (
                            <div>
                                <TextField
                                    label="タイトル"
                                    variant="standard"
                                    sx={{ mt: 2 }}
                                    value={stories.find((story) => story.id === selectedStoryId)?.title || ""}
                                    fullWidth
                                    inputProps={{
                                        readOnly: true,
                                    }}
                                />
                                <TextField
                                    label="内容"
                                    variant="outlined"
                                    sx={{
                                        mt: 2,
                                        mb: 2,
                                        height: "calc(100vh - 220px)",
                                        "& .MuiInputBase-root": {
                                            height: "100%",
                                            "& textarea": {
                                                height: "100% !important",
                                                overflow: "auto !important",
                                            },
                                        },
                                    }}
                                    value={stories.find((story) => story.id === selectedStoryId)?.content || ""}
                                    multiline
                                    rows={getTextFieldRows()}
                                    fullWidth
                                    inputProps={{
                                        readOnly: true,
                                    }}
                                />
                            </div>
                        ) : selectedEndId !== null ? (
                            <div>
                                <TextField
                                    label="タイトル"
                                    variant="standard"
                                    sx={{ mt: 2 }}
                                    value={endings.find((end) => end.id === selectedEndId)?.title || ""}
                                    fullWidth
                                    inputProps={{
                                        readOnly: true,
                                    }}
                                />
                                <TextField
                                    label="内容"
                                    variant="outlined"
                                    sx={{
                                        mt: 2,
                                        height: "calc(100vh - 400px)",
                                        "& .MuiInputBase-root": {
                                            height: "100%",
                                            "& textarea": {
                                                height: "100% !important",
                                                overflow: "auto !important",
                                            },
                                        },
                                    }}
                                    value={endings.find((end) => end.id === selectedEndId)?.content || ""}
                                    multiline
                                    rows={getTextFieldRows()}
                                    fullWidth
                                    inputProps={{
                                        readOnly: true,
                                    }}
                                />
                                <TextField
                                    label="クリア報酬"
                                    variant="outlined"
                                    sx={{ mt: 2, mb: 2 }}
                                    value={endings.find((end) => end.id === selectedEndId)?.reward || ""}
                                    multiline
                                    rows={6}
                                    fullWidth
                                    inputProps={{
                                        readOnly: true,
                                    }}
                                />
                            </div>
                        ) : (
                            <div>
                                <Box></Box>
                            </div>
                        )}
                    </Box>
                ) : (
                    <Grid container spacing={4} sx={{ mt: 8, height: `calc(${viewportHeight}px - 100px)` }}>
                        <Grid item sm={3} sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
                            <TextField
                                label="タイトル"
                                variant="standard"
                                value={title}
                                fullWidth
                                inputProps={{
                                    readOnly: true,
                                }}
                            />
                            <Box
                                sx={{
                                    flex: 1,
                                    overflow: "auto",
                                    mt: 2,
                                    display: "flex",
                                    flexDirection: "column",
                                }}
                            >
                                <List sx={{ mt: 2 }}>
                                    <ListItemButton onClick={handleExpand01}>
                                        <ListItemText primary="キーパー情報" />
                                        {expanded01 ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                                    </ListItemButton>
                                    <Collapse in={expanded01} timeout="auto" unmountOnExit>
                                        <List component="div" disablePadding>
                                            {kpInfo.map((info) => (
                                                <ListItemButton
                                                    key={info.id}
                                                    onClick={() => handleInfoClick(info.id)}
                                                    selected={selectedInfoId === info.id}
                                                >
                                                    <ListItemIcon
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                        }}
                                                    >
                                                        <Checkbox edge="start" />
                                                    </ListItemIcon>
                                                    <ListItemText primary={`${info.title}`} />
                                                </ListItemButton>
                                            ))}
                                        </List>
                                    </Collapse>
                                </List>

                                <List>
                                    <ListItemButton onClick={handleExpand02}>
                                        <ListItemText primary="本編" />
                                        {expanded02 ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                                    </ListItemButton>
                                    <Collapse in={expanded02} timeout="auto" unmountOnExit>
                                        <List component="div" disablePadding>
                                            {stories.map(({ id, title }, index) => (
                                                <ListItemButton key={id} onClick={() => handleStoryClick(id)} selected={selectedStoryId === id}>
                                                    <ListItemIcon
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                        }}
                                                    >
                                                        <Checkbox edge="start" />
                                                    </ListItemIcon>
                                                    <ListItemText primary={title} />
                                                </ListItemButton>
                                            ))}
                                        </List>
                                    </Collapse>
                                </List>

                                <List>
                                    <ListItemButton onClick={handleExpand03}>
                                        <ListItemText primary="エンディング" />
                                        {expanded03 ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                                    </ListItemButton>
                                    <Collapse in={expanded03} timeout="auto" unmountOnExit>
                                        <List component="div" disablePadding>
                                            {endings.map(({ id, title }, index) => (
                                                <ListItemButton key={id} onClick={() => handleEndClick(id)} selected={selectedEndId === id}>
                                                    <ListItemIcon
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                        }}
                                                    >
                                                        <Checkbox edge="start" />
                                                    </ListItemIcon>
                                                    <ListItemText primary={title} />
                                                </ListItemButton>
                                            ))}
                                        </List>
                                    </Collapse>
                                </List>
                            </Box>

                            <Box
                                sx={{ my: 2 }}
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                }}
                            >
                                <Button sx={{ mx: 1, py: 1, width: 190 }} color="secondary" variant="contained" onClick={handleOutput}>
                                    <OutputIcon sx={{ mx: 1 }} /> 出力
                                </Button>
                            </Box>

                            <Box
                                sx={{ my: 2 }}
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                }}
                            >
                                <Button sx={{ mx: 1, py: 1, width: 190 }} variant="contained" onClick={handleEdit} disabled={user !== auther && true}>
                                    <EditIcon sx={{ mx: 1 }} /> 編集
                                </Button>
                            </Box>
                        </Grid>

                        <Grid item sm={9} sx={{ height: "100%", overflowY: "auto" }}>
                            {selectedInfoId === 1 ? (
                                <div>
                                    <Grid
                                        container
                                        spacing={0}
                                        style={{
                                            display: "flex",
                                            justifyContent: "center",
                                        }}
                                    >
                                        <Grid item sm={3}>
                                            <Typography>キーパー難易度</Typography>
                                            <Rating value={kpInfo.find((info) => info.id === 1).kpLevel} readOnly />
                                        </Grid>
                                        <Grid item sm={3}>
                                            <Typography>プレイヤー難易度</Typography>
                                            <Rating value={kpInfo.find((info) => info.id === 1).plLevel} readOnly />
                                        </Grid>
                                        <Grid item sm={3}>
                                            <TextField
                                                label="推奨人数"
                                                variant="standard"
                                                value={kpInfo.find((info) => info.id === 1).numberPeople}
                                                inputProps={{
                                                    readOnly: true,
                                                }}
                                            />
                                        </Grid>
                                        <Grid item sm={3}>
                                            <TextField
                                                label="プレイ時間"
                                                variant="standard"
                                                value={kpInfo.find((info) => info.id === 1).playTime}
                                                inputProps={{
                                                    readOnly: true,
                                                }}
                                            />
                                        </Grid>
                                    </Grid>
                                    <Box sx={{ mt: 3 }}>
                                        <TextField
                                            label="シナリオの概要"
                                            variant="outlined"
                                            value={kpInfo.find((info) => info.id === 1).infoContent}
                                            multiline
                                            rows={getTextFieldRows()}
                                            fullWidth
                                            inputProps={{
                                                readOnly: true,
                                            }}
                                        />
                                    </Box>
                                </div>
                            ) : selectedInfoId === 2 ? (
                                <div style={{ height: "calc(100vh - 150px)", display: "flex", flexDirection: "column" }}>
                                    <TextField
                                        label="技能について"
                                        placeholder="推奨技能などがあれば、記載してください"
                                        variant="outlined"
                                        value={kpInfo.find((info) => info.id === 2).skill}
                                        multiline
                                        rows={3}
                                        fullWidth
                                        inputProps={{
                                            readOnly: true,
                                            style: { alignItems: "flex-start" },
                                        }}
                                        sx={{ mb: 4, flex: "0 0 100px" }}
                                    />
                                    <TextField
                                        label="探索者について"
                                        placeholder="職業の指定や、年齢制限、ハンドアウトなどあれば、記載してください"
                                        variant="outlined"
                                        value={kpInfo.find((info) => info.id === 2).plContent}
                                        multiline
                                        fullWidth
                                        sx={{
                                            flex: 1,
                                            height: "calc(100vh - 400px)",
                                            "& .MuiInputBase-root": {
                                                height: "100%",
                                                overflow: "auto",
                                                "& textarea": {
                                                    height: "100% !important",
                                                    overflow: "auto !important",
                                                },
                                            },
                                        }}
                                        inputProps={{
                                            readOnly: true,
                                            style: { height: "100%", alignItems: "flex-start" },
                                        }}
                                    />
                                </div>
                            ) : selectedInfoId === 3 ? (
                                <div style={{ height: "calc(100vh - 150px)", display: "flex", flexDirection: "column" }}>
                                    <Box sx={{ flex: 1 }}>
                                        <TextField
                                            label="NPC情報"
                                            variant="outlined"
                                            value={kpInfo.find((info) => info.id === 3).npcContent}
                                            multiline
                                            rows={getTextFieldRows()}
                                            fullWidth
                                            inputProps={{
                                                readOnly: true,
                                            }}
                                            sx={{
                                                height: "100%",
                                                "& .MuiInputBase-root": {
                                                    height: "100%",
                                                    "& textarea": {
                                                        height: "100% !important",
                                                    },
                                                },
                                            }}
                                        />
                                    </Box>
                                </div>
                            ) : selectedInfoId === 4 ? (
                                <div style={{ height: "calc(100vh - 150px)", display: "flex", flexDirection: "column" }}>
                                    <Box sx={{ flex: 1 }}>
                                        <TextField
                                            label="アイテム等"
                                            variant="outlined"
                                            value={kpInfo.find((info) => info.id === 4).itemContent}
                                            multiline
                                            rows={getTextFieldRows()}
                                            fullWidth
                                            inputProps={{
                                                readOnly: true,
                                            }}
                                            sx={{
                                                height: "100%",
                                                "& .MuiInputBase-root": {
                                                    height: "100%",
                                                    "& textarea": {
                                                        height: "100% !important",
                                                    },
                                                },
                                            }}
                                        />
                                    </Box>
                                </div>
                            ) : selectedInfoId === 5 ? (
                                <div style={{ height: "calc(100vh - 150px)", display: "flex", flexDirection: "column" }}>
                                    <Box sx={{ flex: 1 }}>
                                        <TextField
                                            label="あらすじ"
                                            variant="outlined"
                                            value={kpInfo.find((info) => info.id === 5).synopsisContent}
                                            multiline
                                            rows={getTextFieldRows()}
                                            fullWidth
                                            inputProps={{
                                                readOnly: true,
                                            }}
                                            sx={{
                                                height: "100%",
                                                "& .MuiInputBase-root": {
                                                    height: "100%",
                                                    "& textarea": {
                                                        height: "100% !important",
                                                    },
                                                },
                                            }}
                                        />
                                    </Box>
                                </div>
                            ) : selectedInfoId === 6 ? (
                                <div style={{ height: "calc(100vh - 150px)", display: "flex", flexDirection: "column" }}>
                                    <Box sx={{ flex: 1 }}>
                                        <TextField
                                            label="真相"
                                            variant="outlined"
                                            value={kpInfo.find((info) => info.id === 6).truthContent}
                                            multiline
                                            rows={getTextFieldRows()}
                                            fullWidth
                                            inputProps={{
                                                readOnly: true,
                                            }}
                                            sx={{
                                                height: "100%",
                                                "& .MuiInputBase-root": {
                                                    height: "100%",
                                                    "& textarea": {
                                                        height: "100% !important",
                                                    },
                                                },
                                            }}
                                        />
                                    </Box>
                                </div>
                            ) : selectedStoryId !== null ? (
                                <div style={{ height: "calc(100vh - 150px)", display: "flex", flexDirection: "column" }}>
                                    <Box sx={{ flex: 1 }}>
                                        <TextField
                                            label="タイトル"
                                            variant="standard"
                                            value={stories.find((story) => story.id === selectedStoryId)?.title || ""}
                                            fullWidth
                                            inputProps={{
                                                readOnly: true,
                                            }}
                                        />
                                    </Box>
                                    <Box sx={{ my: 3 }}>
                                        <TextField
                                            label="内容"
                                            variant="outlined"
                                            value={stories.find((story) => story.id === selectedStoryId)?.content || ""}
                                            multiline
                                            rows={getTextFieldRows()}
                                            fullWidth
                                            inputProps={{
                                                readOnly: true,
                                            }}
                                        />
                                    </Box>
                                </div>
                            ) : selectedEndId !== null ? (
                                <div style={{ height: "calc(100vh - 150px)", display: "flex", flexDirection: "column" }}>
                                    <Box sx={{ flex: 1 }}>
                                        <TextField
                                            label="タイトル"
                                            variant="standard"
                                            value={endings.find((end) => end.id === selectedEndId)?.title || ""}
                                            fullWidth
                                            inputProps={{
                                                readOnly: true,
                                            }}
                                        />
                                    </Box>
                                    <Box sx={{ my: 3 }}>
                                        <TextField
                                            label="内容"
                                            variant="outlined"
                                            value={endings.find((end) => end.id === selectedEndId)?.content || ""}
                                            multiline
                                            rows={getTextFieldRows()}
                                            fullWidth
                                            inputProps={{
                                                readOnly: true,
                                            }}
                                            sx={{
                                                "& .MuiInputBase-root": {
                                                    height: "calc(100vh - 400px)",
                                                    "& textarea": {
                                                        height: "100% !important",
                                                        overflow: "auto !important",
                                                    },
                                                },
                                            }}
                                        />
                                    </Box>
                                    <Box>
                                        <TextField
                                            label="クリア報酬"
                                            variant="outlined"
                                            value={endings.find((end) => end.id === selectedEndId)?.reward || ""}
                                            multiline
                                            rows={5}
                                            fullWidth
                                            inputProps={{
                                                readOnly: true,
                                            }}
                                        />
                                    </Box>
                                </div>
                            ) : (
                                <div>
                                    <Box></Box>
                                </div>
                            )}
                        </Grid>
                    </Grid>
                )}
            </Container>
        </div>
    );
}

export default ScinarioDetail;
